import React, { Component } from "react";
import { BASE_URL } from "../common/common";

const API_URL = BASE_URL;
const MAX_IMAGE_SIZE = 3 * 1024 * 1024; // 3 MB

const imgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return `${path}?ngrok-skip-browser-warning=true`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}?ngrok-skip-browser-warning=true`;
};

class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab : "banner",

      // Banner
      bannerView         : "list",
      bannerList         : [],
      bannerListLoading  : false,
      bannerTitle        : "Team",
      bannerImagePreview : null,
      bannerFile         : null,
      bannerSaving       : false,
      editingBanner      : null,

      // Team Members
      teamView        : "list",
      teamList        : [],
      teamListLoading : false,
      editingMember   : null,

      memberForm: {
        name         : "",
        designation  : "",
        description  : "",
        imagePreview : null,
        imageFile    : null,
        saving       : false,
      },

      successMessage : "",
      errorMessage   : "",
    };
  }

  componentDidMount() {
    this.fetchBannerList();
    this.fetchTeamList();
  }

  showSuccess = (msg) => {
    this.setState({ successMessage: msg, errorMessage: "" });
    setTimeout(() => this.setState({ successMessage: "" }), 3000);
  };

  showError = (msg) => {
    this.setState({ errorMessage: msg, successMessage: "" });
    setTimeout(() => this.setState({ errorMessage: "" }), 4000);
  };

  // ════════════════════════════════
  //  BANNER
  // ════════════════════════════════

  fetchBannerList = async () => {
    this.setState({ bannerListLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/banners/getBanners`, {
        method  : "GET",
        headers : { "ngrok-skip-browser-warning": "true" },
      });
      const json = await res.json();
      if (json.status) {
        const teamBanners = json.data.filter(
          (b) => b.Page_Name?.toLowerCase() === "team"
        );
        this.setState({ bannerList: teamBanners, bannerListLoading: false });
      } else {
        this.setState({ bannerListLoading: false });
        this.showError("Failed to load banners.");
      }
    } catch (err) {
      this.setState({ bannerListLoading: false });
      this.showError("Cannot connect to API server.");
    }
  };

  // Open blank add form
  openBannerForm = () => {
    this.setState({ bannerView: "form", editingBanner: null, bannerTitle: "Team", bannerImagePreview: null, bannerFile: null });
  };

  // Open edit form pre-filled
  openEditBanner = (banner) => {
    this.setState({
      bannerView         : "form",
      editingBanner      : banner,
      bannerTitle        : banner.Page_Name || "Team",
      bannerImagePreview : null,
      bannerFile         : null,
    });
  };

  goToBannerList = () => {
    this.setState({ bannerView: "list", editingBanner: null });
    this.fetchBannerList();
  };

  handleBannerImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) { this.showError("Image size must be less than 3 MB."); e.target.value = ""; return; }
    const reader = new FileReader();
    reader.onloadend = () => this.setState({ bannerImagePreview: reader.result, bannerFile: file });
    reader.readAsDataURL(file);
  };

  removeBannerImage = () => this.setState({ bannerImagePreview: null, bannerFile: null });

  saveBanner = async () => {
    const { bannerTitle, bannerFile, editingBanner } = this.state;
    this.setState({ bannerSaving: true });
    try {
      const formData = new FormData();
      formData.append("page_Name", bannerTitle);
      if (bannerFile) formData.append("files", bannerFile);
      if (editingBanner) formData.append("BannerID", editingBanner.Banner_id);

      const url = editingBanner
        ? `${API_URL}/api/banners/updateBanner`
        : `${API_URL}/api/banners/addBanner`;

      const res  = await fetch(url, { method: "POST", body: formData });
      const json = await res.json();
      this.setState({ bannerSaving: false });
      if (json.status) {
        this.showSuccess(editingBanner ? "Banner updated!" : "Banner saved!");
        setTimeout(() => this.goToBannerList(), 1000);
      } else {
        this.showError(json.message || "Save failed.");
      }
    } catch (err) {
      this.setState({ bannerSaving: false });
      this.showError("Cannot connect to API server.");
    }
  };

  deleteBanner = async (bannerId) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;
    try {
      const res  = await fetch(`${API_URL}/api/banners/deleteBanner`, {
        method  : "POST",
        headers : { "Content-Type": "application/json" },
        body    : JSON.stringify({ id: bannerId }),
      });
      const json = await res.json();
      if (json.status) {
        this.showSuccess("Banner deleted.");
        this.fetchBannerList();
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch (err) {
      this.showError("Cannot connect to API server.");
    }
  };

  // ════════════════════════════════
  //  TEAM MEMBERS
  // ════════════════════════════════

fetchTeamList = async () => {
  this.setState({ teamListLoading: true });
  try {
    const res  = await fetch(`${API_URL}/api/person/getPerson`, {
      method  : "GET",
      headers : { "ngrok-skip-browser-warning": "true" },
    });

    const json = await res.json();

    if (json.status) {
      this.setState({
        teamList: json.data.data,   // ✅ FIXED
        teamListLoading: false
      });
    } else {
      this.setState({ teamListLoading: false });
      this.showError("Failed to load team members.");
    }
  } catch (err) {
    this.setState({ teamListLoading: false });
    this.showError("Cannot connect to API server.");
  }
};

  // Open blank add form
  openTeamForm = () => {
    this.setState({
      teamView      : "form",
      editingMember : null,
      memberForm    : { name: "", designation: "", description: "", imagePreview: null, imageFile: null, saving: false },
    });
  };

  // Open edit form pre-filled
  openEditMember = (member) => {
    this.setState({
      teamView      : "form",
      editingMember : member,
      memberForm: {
        name         : member.name   || "",
        designation  : member.designation  || "",
        description  : member.description  || "",
        imagePreview : null,
        imageFile    : null,
        saving       : false,
      },
    });
  };

  goToTeamList = () => {
    this.setState({ teamView: "list", editingMember: null });
    this.fetchTeamList();
  };

  updateMemberForm = (field, value) => {
    this.setState((prev) => ({ memberForm: { ...prev.memberForm, [field]: value } }));
  };

  handleMemberImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) { this.showError("Image size must be less than 3 MB."); e.target.value = ""; return; }
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState((prev) => ({
        memberForm: { ...prev.memberForm, imagePreview: reader.result, imageFile: file },
      }));
    };
    reader.readAsDataURL(file);
  };

  removeMemberImage = () => {
    this.setState((prev) => ({
      memberForm: { ...prev.memberForm, imagePreview: null, imageFile: null },
    }));
  };

  saveMember = async () => {
    const { memberForm, editingMember } = this.state;

    if (!memberForm.name.trim())        return this.showError("Name is required.");
    if (!memberForm.designation.trim()) return this.showError("Designation is required.");

    this.setState((prev) => ({ memberForm: { ...prev.memberForm, saving: true } }));

    try {
      const formData = new FormData();
      formData.append("name",        memberForm.name);
      formData.append("designation", memberForm.designation);
      formData.append("description", memberForm.description);
      if (memberForm.imageFile) formData.append("image", memberForm.imageFile);

      // If editing, send id for update
      if (editingMember) formData.append("person_id", editingMember.personID);

      const url = editingMember
        ? `${API_URL}/api/person/updatePerson`
        : `${API_URL}/api/person/addPerson`;

      const res  = await fetch(url, { method: "POST", body: formData });
      const json = await res.json();

      this.setState((prev) => ({ memberForm: { ...prev.memberForm, saving: false } }));

      if(editingMember){

       
            this.showSuccess(`${memberForm.name} ${editingMember ? "updated" : "added"} successfully!`);
            setTimeout(() => this.goToTeamList(), 1000);
       
      }else{

          if (json.status) {
            this.showSuccess(`${memberForm.name} ${editingMember ? "updated" : "added"} successfully!`);
            setTimeout(() => this.goToTeamList(), 1000);
          } else {
            this.showError(json.message || "Save failed.");
          }

      }
      
    } catch (err) {
      this.setState((prev) => ({ memberForm: { ...prev.memberForm, saving: false } }));
      this.showError("Cannot connect to API server.");
    }
  };

  deleteMember = async (personId) => {
    if (!window.confirm("Are you sure you want to delete this team member?")) return;
    try {
      const res  = await fetch(`${API_URL}/api/person/deletePerson`, {
        method  : "POST",
        headers : { "Content-Type": "application/json" },
        body    : JSON.stringify({ id: personId }),
      });
      const json = await res.json();
      if (json.message == "Person deleted successfully") {
        this.showSuccess("Team member deleted.");
        this.fetchTeamList();
      } else {
        this.showError(json.message || "Delete failed.");
      }
    } catch (err) {
      this.showError("Cannot connect to API server.");
    }
  };

  // ════════════════════════════════
  //  RENDER
  // ════════════════════════════════
  render() {
    const {
      activeTab,
      bannerView, bannerList, bannerListLoading, bannerTitle, bannerImagePreview, bannerSaving, editingBanner,
      teamView, teamList, teamListLoading, memberForm, editingMember,
      successMessage, errorMessage,
    } = this.state;

    return (
      <div>

        <div className="page-header">
          <h2>Team Page Manager</h2>
          <p>Manage banner and team members for the Team page.</p>
        </div>

        {successMessage && <div style={s.success}>{successMessage}</div>}
        {errorMessage   && <div style={s.error}>{errorMessage}</div>}

        {/* Tabs */}
        <div className="rsp-tab-row" style={s.tabRow}>
          {["banner", "team"].map((tab) => (
            <button
              key={tab}
              style={activeTab === tab ? s.tabActive : s.tab}
              onClick={() => this.setState({ activeTab: tab })}
            >
              {tab === "banner" ? "Banner" : "Team Members"}
            </button>
          ))}
        </div>

        {/* ══ BANNER TAB ══ */}
        {activeTab === "banner" && (
          <div>

            {/* Banner List */}
            {bannerView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {bannerListLoading
                      ? "Loading..."
                      : `${bannerList.length} banner${bannerList.length !== 1 ? "s" : ""} found`}
                  </span>
                  {bannerList.length === 0 && (
                    <button
                      className="rsp-btn-save" style={s.btnSave}
                      onClick={() => this.openBannerForm()}
                    >
                      + Add Banner
                    </button>
                  )}
                </div>

                {bannerListLoading && <div style={s.emptyBox}><p style={s.emptyText}>Loading banners...</p></div>}

                {!bannerListLoading && bannerList.length === 0 && (
                  <div style={s.emptyBox}>
                    <p style={{ ...s.emptyText, marginBottom: "12px" }}>No banners found.</p>
                    <button className="rsp-btn-save" style={s.btnSave} onClick={this.openBannerForm}>+ Add First Banner</button>
                  </div>
                )}

                {!bannerListLoading && bannerList.map((banner, idx) => (
                  <div key={banner.Banner_id || idx} className="rsp-list-card" style={s.listCard}>

                    {banner.imageUrl ? (
                      <img src={imgUrl(banner.imageUrl)} alt="banner" className="rsp-thumb-img" style={s.thumbImg} />
                    ) : (
                      <div style={s.thumbPlaceholder}>No Image</div>
                    )}

                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px" }}>
                        <strong style={s.itemTitle}>{banner.Page_Name || "—"}</strong>
                        <span style={s.idBadge}>ID: {banner.Banner_id}</span>
                      </div>
                      <p style={s.dateText}>
                        Added: {new Date(banner.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                      </p>
                    </div>

                    {/* Edit / Delete */}
                    <div className="rsp-action-btns" style={s.actionBtns}>
                      <button className="rsp-btn-edit" style={s.btnEdit}   onClick={() => this.openEditBanner(banner)}>Edit</button>
                      <button className="rsp-btn-delete" style={s.btnDelete} onClick={() => this.deleteBanner(banner.Banner_id)}>Delete</button>
                    </div>

                  </div>
                ))}
              </div>
            )}

            {/* Banner Form (Add / Edit) */}
            {bannerView === "form" && (
              <div>
                <div className="rsp-form-top" style={s.formTopBar}>
                  <button className="rsp-btn-back" style={s.btnBack} onClick={this.goToBannerList}>Back to List</button>
                  <h3 style={s.formTitle}>
                    {editingBanner ? `Edit Banner — ID ${editingBanner.Banner_id}` : "Add New Banner"}
                  </h3>
                </div>
                <div className="card">

                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Banner Image</label>

                    {/* Show current image when editing */}
                    {editingBanner && !bannerImagePreview && editingBanner.imageUrl && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={{ fontSize: "12px", color: "#888", marginBottom: "6px" }}>Current image:</p>
                        <img src={imgUrl(editingBanner.imageUrl)} alt="current" style={{ width: "200px", height: "80px", objectFit: "cover", borderRadius: "6px", border: "1px solid #e8e8e8" }} />
                      </div>
                    )}

                    {bannerImagePreview ? (
                      <div className="rsp-preview-box" style={s.previewBox}>
                        <img src={bannerImagePreview} alt="Preview" style={s.previewImg} />
                        <div style={s.overlay}>
                          <button className="rsp-btn-delete" style={s.btnDelete} onClick={this.removeBannerImage}>Remove</button>
                          <label className="rsp-btn-dark" style={s.btnDark}>
                            Change
                            <input type="file" accept="image/*" onChange={this.handleBannerImage} style={{ display: "none" }} />
                          </label>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>{editingBanner ? "Click to replace banner image" : "Click to choose banner image"}</p>
                        <p style={s.uploadHint}>JPG, PNG, WEBP — Max 5MB — 1920x600px recommended</p>
                        <input type="file" accept="image/*" onChange={this.handleBannerImage} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>

                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Banner Title</label>
                    <input disabled type="text" value={bannerTitle} onChange={(e) => this.setState({ bannerTitle: e.target.value })} placeholder="e.g. Our Team" className="rsp-input" style={s.input} />
                  </div>

                  <div className="rsp-form-actions" style={s.formActions}>
                    <button className="rsp-btn-back" style={s.btnBack} onClick={this.goToBannerList}>Cancel</button>
                    <button className="rsp-btn-save" style={s.btnSave} onClick={this.saveBanner} disabled={bannerSaving}>
                      {bannerSaving ? "Saving..." : editingBanner ? "Update Banner" : "Save Banner"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ══ TEAM MEMBERS TAB ══ */}
        {activeTab === "team" && (
          <div>

            {/* Team List */}
            {teamView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>
                    {teamListLoading ? "Loading..." : `${teamList.length} member${teamList.length !== 1 ? "s" : ""} found`}
                  </span>
                  <button className="rsp-btn-save" style={s.btnSave} onClick={this.openTeamForm}>+ Add Member</button>
                </div>

                {teamListLoading && <div style={s.emptyBox}><p style={s.emptyText}>Loading team members...</p></div>}

                {!teamListLoading && teamList.length === 0 && (
                  <div style={s.emptyBox}>
                    <p style={{ ...s.emptyText, marginBottom: "12px" }}>No team members found.</p>
                    <button className="rsp-btn-save" style={s.btnSave} onClick={this.openTeamForm}>+ Add First Member</button>
                  </div>
                )}

                {!teamListLoading && teamList.map((member, idx) => (
                  <div key={member.person_id || idx} className="rsp-list-card" style={s.listCard}>

                    {/* Photo */}
                    {member.imageUrl ? (
                      <img src={imgUrl(member.imageUrl)} alt={member.name} style={s.memberThumb} />
                    ) : (
                      <div style={s.memberInitial}>
                        {member.name ? member.name.charAt(0).toUpperCase() : "?"}
                      </div>
                    )}

                    {/* Details */}
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px", flexWrap: "wrap" }}>
                        <strong style={s.itemTitle}>{member.name || "—"}</strong>
                        <span style={s.idBadge}>ID: {member.personID}</span>
                      </div>
                      <p style={s.designationText}>{member.designation || "—"}</p>
                      {member.description && <p style={s.descText}>{member.description}</p>}
                      
                    </div>

                    {/* Edit / Delete */}
                    <div className="rsp-action-btns" style={s.actionBtns}>
                      <button className="rsp-btn-edit" style={s.btnEdit}   onClick={() => this.openEditMember(member)}>Edit</button>
                      <button className="rsp-btn-delete" style={s.btnDelete} onClick={() => this.deleteMember(member.personID)}>Delete</button>
                    </div>

                  </div>
                ))}
              </div>
            )}

            {/* Team Add / Edit Form */}
            {teamView === "form" && (
              <div>
                <div className="rsp-form-top" style={s.formTopBar}>
                  <button className="rsp-btn-back" style={s.btnBack} onClick={this.goToTeamList}>Back to List</button>
                  <h3 style={s.formTitle}>
                    {editingMember ? `Edit Member — ${editingMember.personName}` : "Add New Member"}
                  </h3>
                </div>

                <div className="card">

                  {/* Member Photo */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Member Photo</label>

                    {/* Show current photo when editing */}
                    {editingMember && !memberForm.imagePreview && editingMember.imageUrl && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={{ fontSize: "12px", color: "#888", marginBottom: "6px" }}>Current photo:</p>
                        <img src={imgUrl(editingMember.imageUrl)} alt="current" style={{ width: "80px", height: "80px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8" }} />
                      </div>
                    )}

                    {memberForm.imagePreview ? (
                      <div style={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>
                        <img src={memberForm.imagePreview} alt="preview" style={s.memberThumbLg} />
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>
                            Change Photo
                            <input type="file" accept="image/*" onChange={this.handleMemberImage} style={{ display: "none" }} />
                          </label>
                          <button className="rsp-btn-delete" style={s.btnDelete} onClick={this.removeMemberImage}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label className="rsp-upload-box" style={s.uploadBox}>
                        <p style={s.uploadText}>{editingMember ? "Click to replace photo" : "Click to upload member photo"}</p>
                        <p style={s.uploadHint}>JPG, PNG — Recommended: square image</p>
                        <input type="file" accept="image/*" onChange={this.handleMemberImage} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>

                  {/* Name & Designation */}
                  <div className="rsp-two-col" style={s.twoCol}>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Full Name *</label>
                      <input className="rsp-input" style={s.input} type="text" value={memberForm.name} placeholder="e.g. Nadeem Anwar" onChange={(e) => this.updateMemberForm("name", e.target.value)} />
                    </div>
                    <div className="rsp-form-group" style={s.formGroup}>
                      <label style={s.label}>Designation *</label>
                      <input className="rsp-input" style={s.input} type="text" value={memberForm.designation} placeholder="e.g. Founder & Director" onChange={(e) => this.updateMemberForm("designation", e.target.value)} />
                    </div>
                  </div>

                  {/* Description */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Description</label>
                    <textarea className="rsp-textarea" style={s.textarea} value={memberForm.description} placeholder="Brief bio about this team member..." onChange={(e) => this.updateMemberForm("description", e.target.value)} />
                  </div>

                  <div className="rsp-form-actions" style={s.formActions}>
                    <button className="rsp-btn-back" style={s.btnBack} onClick={this.goToTeamList}>Cancel</button>
                    <button className="rsp-btn-save" style={s.btnSave} onClick={this.saveMember} disabled={memberForm.saving}>
                      {memberForm.saving ? "Saving..." : editingMember ? `Update ${memberForm.name || "Member"}` : `Save ${memberForm.name || "Member"}`}
                    </button>
                  </div>

                </div>
              </div>
            )}
          </div>
        )}

      </div>
    );
  }
}

const s = {
  success          : { background: "#e8f5e9", color: "#2e7d32", border: "1px solid #c8e6c9", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", fontSize: "14px" },
  error            : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", fontSize: "14px" },
  tabRow           : { display: "flex", gap: "10px", borderBottom: "2px solid #e8e8e8", marginBottom: "20px" },
  tab              : { padding: "10px 20px", background: "none", border: "none", borderBottom: "3px solid transparent", fontSize: "14px", color: "#888", cursor: "pointer", marginBottom: "-2px", fontWeight: "500" },
  tabActive        : { padding: "10px 20px", background: "none", border: "none", borderBottom: "3px solid #e8a020", fontSize: "14px", color: "#e8a020", cursor: "pointer", marginBottom: "-2px", fontWeight: "600" },
  listTopBar       : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" },
  countText        : { fontSize: "14px", color: "#888" },
  listCard         : { background: "white", borderRadius: "10px", padding: "18px 20px", border: "1px solid #e8e8e8", marginBottom: "12px", display: "flex", alignItems: "center", gap: "16px" },
  itemTitle        : { fontSize: "15px", color: "#1a1a2e" },
  idBadge          : { background: "#f0f2f5", color: "#888", border: "1px solid #e0e0e0", borderRadius: "10px", padding: "2px 8px", fontSize: "11px" },
  designationText  : { fontSize: "13px", color: "#e8a020", fontWeight: "500", marginBottom: "4px" },
  descText         : { fontSize: "12px", color: "#666", marginBottom: "6px", lineHeight: "1.6" },
  dateText         : { fontSize: "11px", color: "#bbb", marginTop: "4px" },
  emptyBox         : { background: "white", borderRadius: "10px", padding: "48px 20px", border: "1px solid #e8e8e8", textAlign: "center" },
  emptyText        : { color: "#aaa", fontSize: "14px" },
  thumbImg         : { width: "100px", height: "60px", objectFit: "cover", borderRadius: "6px", border: "1px solid #e8e8e8", flexShrink: 0 },
  thumbPlaceholder : { width: "100px", height: "60px", background: "#f0f2f5", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", color: "#aaa", flexShrink: 0 },
  memberThumb      : { width: "60px", height: "60px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8", flexShrink: 0 },
  memberThumbLg    : { width: "100px", height: "100px", objectFit: "cover", borderRadius: "50%", border: "2px solid #e8e8e8" },
  memberInitial    : { width: "60px", height: "60px", background: "#1a1a2e", color: "#e8a020", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", fontWeight: "700", flexShrink: 0 },
  actionBtns       : { display: "flex", flexDirection: "column", gap: "6px", flexShrink: 0 },
  btnEdit          : { background: "#e3f2fd", color: "#1565c0", border: "1px solid #bbdefb", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600", minWidth: "64px" },
  btnDelete        : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600", minWidth: "64px" },
  formTopBar       : { display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" },
  formTitle        : { fontSize: "16px", color: "#1a1a2e", margin: 0 },
  formActions      : { display: "flex", justifyContent: "flex-end", gap: "10px", borderTop: "1px solid #f0f0f0", paddingTop: "16px" },
  formGroup        : { marginBottom: "16px" },
  label            : { display: "block", fontSize: "13px", color: "#555", fontWeight: "600", marginBottom: "6px" },
  input            : { width: "100%", padding: "10px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", fontFamily: "Arial, sans-serif" },
  textarea         : { width: "100%", padding: "10px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", minHeight: "100px", resize: "vertical", fontFamily: "Arial, sans-serif" },
  uploadBox        : { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "2px dashed #ddd", borderRadius: "10px", padding: "36px 20px", cursor: "pointer", background: "#fafafa", textAlign: "center" },
  uploadText       : { fontSize: "14px", color: "#555", marginBottom: "4px" },
  uploadHint       : { fontSize: "11px", color: "#aaa" },
  previewBox       : { position: "relative", borderRadius: "10px", overflow: "hidden", border: "1px solid #e8e8e8" },
  previewImg       : { width: "100%", height: "200px", objectFit: "cover", display: "block" },
  overlay          : { position: "absolute", bottom: "10px", right: "10px", display: "flex", gap: "8px" },
  btnRed           : { background: "#e53935", color: "#fff", border: "none", padding: "7px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600" },
  btnDark          : { background: "#1a1a2e", color: "#fff", border: "none", padding: "7px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600" },
  btnSave          : { background: "#e8a020", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: "pointer" },
  btnBack          : { background: "#f0f2f5", color: "#333", border: "1px solid #ddd", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", cursor: "pointer", fontWeight: "500" },
  twoCol           : { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" },
  hint             : { fontSize: "11px", color: "#aaa", marginTop: "5px", display: "block" },
};

export default Team;